module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_f_albino.b667be5f.png";